export const lineSeriesProps = {
  dot: false,
  type: "monotone" as const,
  strokeWidth: 2.5,
  connectNulls: true,
  isAnimationActive: false,
};
